import React, {useContext, useState, useEffect} from "react";

import {Form, Select, Input, Typography} from "antd";

import {properties} from "../../properties";
import {ModalWindow} from "../helpers/modals/ModalWindow";
import {CurrentUserContext} from "../../contexts/AuthContext";

export function ArchiveIterationModal({isModalVisible, setIsModalVisible, iteration, onFinish}) {
    const close = () => setIsModalVisible(false);
	const [form] = Form.useForm();

	const user = useContext(CurrentUserContext);

	const handleCancel = () => {
		closeModal();
	};

	form.setFieldsValue({
        iteration_name: iteration?.iteration_name || "",
        scenario_scope: iteration?.scope?.name || "",
        archived_by: user.email(),
        add_info: "",
    });

	return (
		<ModalWindow
			width={900}
			title={`Archive Scenario`}
			isModalVisible={isModalVisible}
			scrollVisible={false}
			onCancel={close}
			modalProps={{
				okText: "Submit",
				cancelText: "Cancel",
				okButtonProps: {form: "iterationArchiveForm", key: "submit", htmlType: "submit"},
			}}>
			<Form onFinish={(values) => onFinish(values, iteration?._id)}
			      form={form} id="iterationArchiveForm"
			>
				<Form.Item label=<b>Scenario Name</b> name="iteration_name">
				      <Typography.Text><b> {form.getFieldValue("iteration_name")} </b></Typography.Text>
				</Form.Item>
				<Form.Item label=<b>Scenario Scope</b> name="scenario_scope">
				    <Typography.Text><b> {form.getFieldValue("scenario_scope")} </b></Typography.Text>
				</Form.Item>
				<Form.Item label=<b>Archived by</b> name="archived_by">
				    <Typography.Text><b> {form.getFieldValue("archived_by")} </b></Typography.Text>
				</Form.Item>
				<Form.Item label=<b>Additional Information</b> name="add_info">
					<Input/>
				</Form.Item>
			</Form>
		</ModalWindow>
	);
}

